import {relayPositionFields} from '../HighLevelTournamentEvents/RelayPositions';
import { studentBirthdayColumn } from 'Src/components/StudentBirthday/StudentBirthday';
import {TournamentAvailabilityIcon, playerAvailabilityStatus, tournamentAvailabilityOptions} from 'Src/components/TournamentAvailabilityIcon/TournamentAvailabilityIcon';
import {errorMessage} from 'Src/helpers/service/adminSU/highLevelTournament';
import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { parse } from 'query-string';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { History, Location } from 'history';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { Loader } from 'Src/components/Loader/Loader';
import { FILTER_TYPE, FIRST_PAGE, DATE_INTERVAL } from 'Src/consts/table';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { TournamentSelectionSources } from 'Src/components/TournamentSelectionSources/TournamentSelectionSources';
import '../HighLevelTournamentWorkflow.scss';
import '../../../AdminView/Invites/SchoolInvitesHub.scss';
import './HighLevelTournamentTeamPlayers.scss';
import { statusLabel } from 'Src/helpers/service/adminSU/highLevelTournament';
import { AvailabilityRequestDialog } from '../TournamentAvailability/AvailabilityRequestDialog';
import { getGender } from 'Src/helpers/accessor/accessor';
import {
  getHighLevelTournamentTeamPlayers,
  getHighLevelTournamentTeamPlayersCount,
  getAllHighLevelTournamentTeamPlayers
} from 'Src/helpers/service/adminSU/tournamentsTable';
import {
  getSelectOptionForAge,
  getSelectOptionForSchoolOfTeam,
  getSelectOptionForGender
} from 'Src/helpers/table/select';
import { removeSchoolEventTeamPlayer } from 'Src/helpers/service/admin/tournamentTeams';
import { removeSchoolEventIndividualPlayer } from 'Src/helpers/service/admin/tournamentTeams';
import { updateSchoolEventIndividualsBatch } from 'Src/helpers/service/admin/schoolEventIndividuals';
import { updateSchoolEventTeamPlayersBatch } from 'Src/helpers/service/admin/event';
import { addSchoolEventTeam } from 'Src/helpers/service/admin/tournamentTeams';
import { getTeamPlayerAgesGroup } from 'Src/helpers/accessor/accessor';
import { getTeamPlayerEventsIcon } from 'Src/helpers/cell/cell';
import { CELL_ACTION_ICON } from 'Src/consts/cell';
import { Checkbox } from 'Src/components/Checkbox/Checkbox';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import { getSchoolEvent } from 'Src/helpers/service/admin/event';
import { updateSchoolTournamentTeamPlayersBatch } from 'Src/helpers/service/admin/tournamentTeamPlayers';
import { AddPlayerToEventForm } from './HighLevelTournamentAddPlayerToEventForm';
import { IndividualTournamentTeamPlayer, TournamentTeamPlayerEvent } from 'Src/models/tournamentTeamPlayer';
import { SchoolEvent } from 'Src/models/event';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { SchoolForm } from 'Src/models/form';
import {
  SchoolUnionSchoolStudentForm,
  SchoolUnionSchoolStudentFormHandle
} from 'Src/components/SchoolUnionSchoolStudentForm/SchoolUnionSchoolStudentForm';
import { updateSchoolUnionSchoolStudent } from 'Src/helpers/service/adminSU/schoolStudentsTable';

interface Props {
  user: AppUser;
  history: History;
  location: Location;
  participationReadOnly?: boolean;
  participationTournament?: any;
  onTeamMemberCountChange?: (teamId: string, count: number) => void;
}

interface State {
  items: IndividualTournamentTeamPlayer[];
  currentPage: number;
  selectedItems: IndividualTournamentTeamPlayer[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  filters: any;
  isDataFiltered: boolean;
  isLoading: boolean;
  isSavingAllocations: boolean;
  total: number;
  basePath: string;
  isSelectAllChecked: boolean;
  modalText: string;
  isEditTeamModalOpen: boolean;
  isRemovePlayerFromEventConfirmationModalOpen: boolean;
  isRemovePlayerFromTeamConfirmationModalOpen: boolean;
  isRemovePlayerFromTeamProhibitionModalOpen: boolean;
  isAddPlayerToEventModalOpen: boolean;
  forms: SchoolForm[];

  eventIdToRemove: string;
  currentPlayer: IndividualTournamentTeamPlayer | undefined;
  isAskToRemovePlayerFromEvent: boolean;

  errorMessage: string;

  isEditStudentModalOpen: boolean;
  studentToEdit: IndividualTournamentTeamPlayer | null;
  isAvailabilityRequestOpen: boolean;
}

type EventAssignmentPatch = {
  positionId: string | null;
  isCaptain: boolean;
  sub: boolean;
};

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Student',
    field: 'name',
    cell: item => <td className="hltTeamMembers__student"><TournamentAvailabilityIcon player={item} />{getFullName(item)}</td>,
    type: FILTER_TYPE.TEXT,
    isSort: false
  },
  studentBirthdayColumn,
  {
    text: 'School',
    field: 'schoolId',
    accessor: ['schoolName'],
    type: FILTER_TYPE.MULTISELECT,
    isSort: false
  },
  {
    text: 'Age group',
    field: 'ages',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getTeamPlayerAgesGroup
  },
  {
    text: 'Gender',
    field: 'gender',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: getGender
  },
  {
    text: 'School availability',
    field: 'tournamentAvailability',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    cell: (item: IndividualTournamentTeamPlayer) => {
      const status = item.availabilityRequested || (item.tournamentAvailability && item.tournamentAvailability !== 'PENDING') ? item.tournamentAvailability || 'PENDING' : undefined;
      return <td><span className={`hltTeamMembers__status hltTeamMembers__status--${status || 'UNREQUESTED'}`}>
        {status ? statusLabel(status) : 'Not requested'}
      </span></td>;
    }
  },
  {
    text: 'Event allocations',
    field: 'events',
    isSort: false,
    type: FILTER_TYPE.NONE,
    cell: getTeamPlayerEventsIcon
  },
  {text: 'Selection source', field: 'selectionSources', type: FILTER_TYPE.NONE, isSort: false,
    cell: (item: IndividualTournamentTeamPlayer) => <td className="hltTeamMembers__source">{item.selectionSources?.length
      ? <TournamentSelectionSources sources={item.selectionSources} /> : <span className="hltTeamMembers__unallocated">Added directly</span>}</td>},
  {
    text: 'Actions',
    field: 'actions',
    cell: () => <td />,
    isSort: false,
    type: FILTER_TYPE.NONE,
    align: 'right'
  }
];

export class HighLevelTournamentTeamPlayers extends Component<Props, State> {
  private studentFormRef = React.createRef<SchoolUnionSchoolStudentFormHandle>();

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      filters: {},
      isDataFiltered: false,
      isSavingAllocations: false,
      isLoading: false,
      total: 0,
      basePath: '',
      isSelectAllChecked: false,
      modalText: '',
      isEditTeamModalOpen: false,
      isRemovePlayerFromEventConfirmationModalOpen: false,
      isRemovePlayerFromTeamConfirmationModalOpen: false,
      isRemovePlayerFromTeamProhibitionModalOpen: false,
      isAddPlayerToEventModalOpen: false,
      forms: [],
      eventIdToRemove: '',
      currentPlayer: undefined,
      isAskToRemovePlayerFromEvent: false,
      errorMessage: '',
      isEditStudentModalOpen: false,
      studentToEdit: null,
      isAvailabilityRequestOpen: false
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  setAdditionalItems() {
    const { user } = this.props;

    return getAllForms(user).then(forms => {
      this.setState({
        forms
      });
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems(nextProps);
    }
  }

  setItems(props: Props = this.props) {
    const { history, user } = props;
    const { forms } = this.state;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    const options = {
      forms
    };

    const where = getServerFieldSectionWhere(filters, options);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const tournamentId = this.getTournamentId(props);
    const teamId = this.getTeamId(props);

    this.setState({
      isLoading: true
    });

    const getItemsPromise = getHighLevelTournamentTeamPlayers(user, tournamentId, teamId, serverQueryFilter);
    const getItemsCountPromise = getHighLevelTournamentTeamPlayersCount(user, tournamentId, teamId, where);

    const totalCountPromise = props.onTeamMemberCountChange && isDataFiltered
      ? getHighLevelTournamentTeamPlayersCount(user, tournamentId, teamId, undefined)
      : getItemsCountPromise;
    return Promise.all([getItemsPromise, getItemsCountPromise, totalCountPromise]).then(([items, countObj, totalCountObj]) => {
      props.onTeamMemberCountChange?.(teamId, totalCountObj.count);
      this.setState({
        currentPage: page,
        sortDirection: sortDirection,
        sortColumnsName: sortColumnsName,
        isShowFilter: isShowFilter,
        isDataFiltered: isDataFiltered,
        filters: filters,
        items: items,
        total: countObj.count,
        basePath: history.location.pathname,
        isLoading: false
      });

      return true;
    });
  }

  goBack = () => {
    const { history, location } = this.props;
    const { state } = location;
    const search = propz.get(state, ['search'], '');
    const tournamentId = this.getTournamentId();

    history.push({
      pathname: '/highLevelTournaments/teams',
      search: `tournamentId=${tournamentId}`,
      state: { search }
    });
  };

  getTournamentId(props: Props = this.props): string {
    const { history } = props;
    const search = parse(history.location.search);
    const tournamentId = search.tournamentId;
    return tournamentId;
  }

  getTeamId(props: Props = this.props): string {
    const { history } = props;
    const search = parse(history.location.search);
    const teamId = search.teamId;
    return teamId;
  }

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedItem = items[index];

    const selectedItemIndex = selectedItems.findIndex(item => selectedItem.id === item.id);
    let selectedItemsUpdated = [...selectedItems];

    if (selectedItemIndex !== -1) {
      selectedItemsUpdated.splice(selectedItemIndex, 1);
    } else {
      selectedItemsUpdated.push(selectedItem);
    }

    this.setState({
      selectedItems: selectedItemsUpdated
    });
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false, filters: getFilters2(COLUMNS, parse(this.props.history.location.search)) });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    this.setState(prevState => {
      return {
        isShowFilter: !prevState.isShowFilter
      };
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      if (!filter) return;
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value: string[] = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { location } = this.props;
    const { state } = location;
    const locationSearch = propz.get(state, ['search'], '');
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    const teamName = propz.get(location, ['state', 'teamName'], '');

    const { history } = this.props;
    const { basePath } = this.state;
    const teamId = this.getTeamId();
    const tournamentId = this.getTournamentId();

    history.push({
      pathname: basePath,
      search: `teamId=${teamId}&tournamentId=${tournamentId}&${search.join('&')}`,
      state: { search: locationSearch, teamName }
    });
  };

  onClearFilterClick = (): void => {
    const { location } = this.props;
    const { state } = location;
    const locationSearch = propz.get(state, ['search'], '');

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    const { history } = this.props;
    const { basePath } = this.state;
    const teamId = this.getTeamId();
    const tournamentId = this.getTournamentId();

    const teamName = propz.get(location, ['state', 'teamName'], '');

    history.push({
      pathname: basePath,
      search: `teamId=${teamId}&tournamentId=${tournamentId}`,
      state: { search: locationSearch, teamName }
    });
  };

  onCellIconClick = (
    data: {
      currentPlayer: IndividualTournamentTeamPlayer;
      currentEvent?: TournamentTeamPlayerEvent;
      newAssignment?: EventAssignmentPatch;
    },
    cell: string
  ) => {
    if (this.props.participationReadOnly) return;
    const { isAskToRemovePlayerFromEvent } = this.state;
    const { currentPlayer, currentEvent } = data;
    const playerFullName = getFullName(currentPlayer);

    switch (true) {
      case cell === CELL_ACTION_ICON.ADD_TO_EVENT:
        this.setState({
          currentPlayer
        });

        this.openAddPlayerToEventModal();
        break;

      case cell === CELL_ACTION_ICON.REMOVE_FROM_EVENT:
        if (!currentEvent) break;

        const { id } = currentEvent;
        const eventName = propz.get(currentEvent, ['generatedNames', 'official'], '');

        this.setState(
          {
            modalText: `${playerFullName} will be removed from ${eventName}. Are you sure?`,
            eventIdToRemove: id,
            currentPlayer
          },
          () => {
            isAskToRemovePlayerFromEvent
              ? this.removePlayerFromEvent()
              : this.openRemovePlayerFromEventConfirmationModal();
          }
        );
        break;

      case cell === CELL_ACTION_ICON.REMOVE_FROM_TEAM:
        const { events } = currentPlayer;
        const IsEventsExist = events.length > 0;

        this.setState(
          {
            modalText: IsEventsExist ? '' : `${playerFullName} will be removed from the team. Are you sure?`,
            currentPlayer
          },
          () => {
            IsEventsExist && playerAvailabilityStatus(currentPlayer) !== 'NOT_AVAILABLE'
              ? this.openRemovePlayerFromTeamProhibitionModal()
              : this.openRemovePlayerFromTeamConfirmationModal();
          }
        );

        break;

      case cell === CELL_ACTION_ICON.EDIT:
        this.handleEditClick(currentPlayer);
        break;

      case cell === CELL_ACTION_ICON.UPDATE_EVENT_ASSIGNMENT: {
        if (!currentEvent) break;
        if (currentEvent.teamBased === false) break;
        this.updateEventAssignment(currentPlayer, currentEvent, data.newAssignment);
        break;
      }
    }
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;
    const { history } = this.props;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const tournamentId = this.getTournamentId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;
    const { history } = this.props;

    if (currentPage !== FIRST_PAGE) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    this.props.history.push({
      pathname: this.state.basePath,
      search: `teamId=${teamId}&tournamentId=${tournamentId}&${search.join('&')}`,
      state: history.location.state
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters, forms } = this.state;

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const options = {
      forms
    };

    const where = getServerFieldSectionWhere(filters, options);

    const tournamentId = this.getTournamentId();
    const teamId = this.getTeamId();

    getAllHighLevelTournamentTeamPlayers(user, tournamentId, teamId, where).then(items => {
      const itemsFiltered = items.filter(item => {
        return selectedItems.every(selectedItem => selectedItem.id !== item.id);
      });

      const nextSelectedItems = [...selectedItems, ...itemsFiltered];

      this.setState({
        selectedItems: nextSelectedItems,
        isSelectAllChecked: true,
        isLoading: false
      });
    }).catch(error => this.setState({isLoading: false, errorMessage: errorMessage(error)}));
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const itemsFiltered = items.filter(item => {
      return selectedItems.every(selectedItem => selectedItem.id !== item.id);
    });

    const nextSelectedItems = [...selectedItems, ...itemsFiltered];

    this.setState({
      selectedItems: nextSelectedItems,
      isSelectAllChecked: true
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  removePlayerFromEvent = (): void => {
    const { user } = this.props;
    const { eventIdToRemove, currentPlayer } = this.state;

    if (!currentPlayer) return;

    const removePlayerId = currentPlayer.userId;

    this.setState({ isLoading: true });

    getSchoolEvent(user, eventIdToRemove)
      .then(schoolEvent => {
        const isRelay = propz.get(schoolEvent, ['sport', 'isRelay'], false);

        const { players } = schoolEvent;
        const foundPlayer = players.find(player => player.userId === removePlayerId);

        if (!foundPlayer) return Promise.reject('Player not found');

        const teamId = (foundPlayer as any).teamId;
        const playerId = (foundPlayer as any)._id;

        return isRelay
          ? removeSchoolEventTeamPlayer(user, eventIdToRemove, teamId, playerId)
          : removeSchoolEventIndividualPlayer(user, eventIdToRemove, playerId);
      })
      .then(() => this.setItems())
      .then(() => {
        this.setState({
          selectedItems: [],
          isSelectAllChecked: false,
          isRemovePlayerFromEventConfirmationModalOpen: false,
          modalText: '',
          isLoading: false,
          currentPlayer: undefined
        });
	  })
	  .catch(error => {
		this.setState({ isLoading: false });
		window.alert(propz.get(error, ['response', 'data', 'details', 'text'], 'The student could not be removed. Please try again.'));
	  });
  };

  addPlayerToEvent = (
    assignments: {
      event: SchoolEvent;
      students: IndividualTournamentTeamPlayer[];
      playersToReplace: { eventId: string; playerId: string }[];
      positions?: Record<string, string>;
    }[]
  ): void => {
    if (this.state.isSavingAllocations) return;
    this.setState({ isLoading: true, isSavingAllocations: true });

    const { user } = this.props;

    const removePromises = assignments.filter(({event}) => !propz.get(event, ['sport', 'isRelay'], false)).reduce((acc: Promise<any>[], { playersToReplace }) => {
      return [
        ...acc,
        ...playersToReplace.map(({ eventId, playerId }) => removeSchoolEventIndividualPlayer(user, eventId, playerId))
      ];
    }, []);

    const submitWithLimitOverride = (submit: (override: boolean) => Promise<any>) =>
      submit(false).catch(error => {
        const text = propz.get(error, ['response', 'data', 'details', 'text'], '');
        if (text.indexOf('organising union may override') !== -1 && window.confirm(
          `WARNING\n\n${text}\n\nDo you want to make this exceptional entry?`
        )) return submit(true);
        throw error;
      });
    const addJobs = assignments.map(({ event, students, playersToReplace, positions }) => () => {
      const { id: eventId, ages, gender } = event;
      const studentData = students.map(s => ({
        permissionId: s.permissionId,
        userId: s.userId,
        ...relayPositionFields(event, s, positions)
      }));

      const isRelay = propz.get(event, ['sport', 'isRelay'], false);

      if (isRelay) {
        const teamsData = propz.get(event, ['teamsData'], []);
        const schoolTeam = teamsData.find((team: any) => String(team.schoolId) === String(user.activeSchoolId));
        const isSchoolTeamExist = typeof schoolTeam !== 'undefined';
        const teamToAdd = { ages, gender, players: studentData };

        return isSchoolTeamExist
            ? submitWithLimitOverride(override => updateSchoolEventTeamPlayersBatch(user, eventId, schoolTeam.id, { add: studentData, ...(playersToReplace.length ? {remove: playersToReplace.map(row => row.playerId)} : {}) }, override))
            : submitWithLimitOverride(override => addSchoolEventTeam(user, eventId, teamToAdd, override));
      } else {
        return submitWithLimitOverride(override => updateSchoolEventIndividualsBatch(user, eventId, { add: studentData }, override));
      }
    });

    Promise.all(removePromises)
      .then(async () => {for (const add of addJobs) await add();})
      .then(() => this.setItems())
      .then(() => {
        this.setState({
          selectedItems: [],
          isSelectAllChecked: false,
          isLoading: false,
          isSavingAllocations: false,
          isAddPlayerToEventModalOpen: false,
          currentPlayer: undefined
        });
	  })
	  .catch(error => {
		this.setState({ isLoading: false, isSavingAllocations: false });
		window.alert(propz.get(error, ['response', 'data', 'details', 'text'], 'The students could not be added. Please try again.'));
	  });
  };

  handleEditClick = (player: IndividualTournamentTeamPlayer) => {
    this.setState({
      isEditStudentModalOpen: true,
      studentToEdit: player
    });
  };

  openEditStudentModal = () => {
    const { selectedItems } = this.state;
    if (selectedItems.length === 1) {
      this.setState({
        isEditStudentModalOpen: true,
        studentToEdit: selectedItems[0]
      });
    }
  };

  closeEditStudentModal = () => {
    this.setState({
      isEditStudentModalOpen: false,
      studentToEdit: null
    });
  };

  onSubmitEditStudent = async (
    formData: any,
    isContinue: boolean,
    isSavingSimilarStudentConfirmed: boolean = false
  ): Promise<boolean> => {
    const { user } = this.props;
    const { studentToEdit } = this.state;

    if (!studentToEdit) return false;

    const formId = formData.form?.id || studentToEdit.form?.id;

    try {
      await updateSchoolUnionSchoolStudent(user, studentToEdit.schoolId, studentToEdit.userId, {
        ...formData,
        formId
      });

      await this.setItems();
      this.closeEditStudentModal();
      return true;
    } catch (error) {
      console.error('Error updating student:', error);
      this.setState({
        errorMessage: 'Failed to update student. Please try again.'
      });
      return false;
    }
  };

  renderEditStudentModal() {
    const { isEditStudentModalOpen, studentToEdit, forms } = this.state;
    const { user } = this.props;
    if (!isEditStudentModalOpen || !studentToEdit) return null;

    return (
      <SimpleModal
        isOpen={isEditStudentModalOpen}
        onCloseClick={() => this.studentFormRef.current?.requestClose()}
        title="Edit Student"
        showFooter={false}
        customClass="unionStudentModal"
        dialogStyle={{ maxWidth: 560 }}
      >
        <SchoolUnionSchoolStudentForm
          ref={this.studentFormRef}
          student={studentToEdit}
          user={user}
          onSubmit={this.onSubmitEditStudent}
          onCancel={this.closeEditStudentModal}
          isCreateStudentsChain={false}
          identicalStudents={[]}
          similarStudents={[]}
          isFormsExist={forms && forms.length > 0}
          isEditStudent={true}
          schoolId={studentToEdit.schoolId}
        />
      </SimpleModal>
    );
  }

  removePlayerFromTeam = async (): Promise<void> => {
    const {user} = this.props;
    const selected = this.state.currentPlayer ? [this.state.currentPlayer] : this.state.selectedItems;
    const tournamentId = this.getTournamentId(), teamId = this.getTeamId();
    this.setState({isLoading: true, errorMessage: ''});
    let removingAllocations = false;
    try {
      if (selected.some(player => player.events?.length)) {
        // Refresh the selected children before starting the explicitly confirmed cleanup.
        const latest = await getAllHighLevelTournamentTeamPlayers(user, tournamentId, teamId, {userId: {$in: selected.map(player => player.userId)}});
        const ids = new Set(selected.map(player => player.id));
        const fresh = latest.filter(player => ids.has(player.id));
        if (fresh.length !== selected.length || fresh.some(player => playerAvailabilityStatus(player) !== 'NOT_AVAILABLE')) throw new Error('The selected students changed. Refresh their availability before removing them.');
        const pairs = new Set(fresh.map(player => `${player.userId}:${player.permissionId}`));
        const eventIds = [...new Set<string>(fresh.reduce((ids, player) => ids.concat(player.events.map(event => event.id)), [] as string[]))];
        removingAllocations = true;
        for (const eventId of eventIds) {
          const event = await getSchoolEvent(user, eventId);
          const ownTeams = new Set((event.embeddedTeams || []).filter(team => String(team.schoolId) === user.activeSchoolId).map(team => String(team._id || (team as any).id)));
          const players = (event.players || []).filter(player => pairs.has(`${player.userId}:${player.permissionId}`) && (String(player.schoolId) === user.activeSchoolId || ownTeams.has(String(player.teamId))));
          const individuals = players.filter(player => !player.teamId);
          if (individuals.length) await updateSchoolEventIndividualsBatch(user, eventId, {remove: individuals.map(player => String(player._id))});
          const teams = [...new Set(players.filter(player => player.teamId).map(player => String(player.teamId)))];
          for (const id of teams) await updateSchoolEventTeamPlayersBatch(user, eventId, id, {remove: players.filter(player => String(player.teamId) === id).map(player => String(player._id))});
        }
      }
      await updateSchoolTournamentTeamPlayersBatch(user, tournamentId, teamId, {remove: selected.map(player => player.id)});
      this.setState({isRemovePlayerFromTeamConfirmationModalOpen: false, modalText: '', currentPlayer: undefined, selectedItems: [], isSelectAllChecked: false});
      await this.setItems();
    } catch(error) {
      this.setState({errorMessage: errorMessage(error) + (removingAllocations ? ' Some event allocations may already have been removed. Review the list and retry.' : '')});
    } finally {this.setState({isLoading: false});}
  };

  renderRemovePlayerFromEventConfirmationModal() {
    const { isRemovePlayerFromEventConfirmationModalOpen, isAskToRemovePlayerFromEvent, modalText } = this.state;

    return (
      <SimpleModal
        isOpen={isRemovePlayerFromEventConfirmationModalOpen}
        title="Confirm the action"
        body={modalText}
        buttonText="Confirm"
        buttonCancelText="Cancel"
        onButtonClick={() => this.removePlayerFromEvent()}
        onCloseClick={this.closeRemovePlayerFromEventConfirmationModal}
      >
        <Checkbox
          customClass="mt-2"
          id="12"
          value={isAskToRemovePlayerFromEvent}
          labelText="Don't ask anymore"
          onChange={() =>
            this.setState(prevState => {
              return {
                isAskToRemovePlayerFromEvent: !prevState.isAskToRemovePlayerFromEvent
              };
            })
          }
        />
      </SimpleModal>
    );
  }

  openRemovePlayerFromEventConfirmationModal = (): void => {
    this.setState({
      isRemovePlayerFromEventConfirmationModalOpen: true
    });
  };

  closeRemovePlayerFromEventConfirmationModal = (): void => {
    this.setState({
      isAskToRemovePlayerFromEvent: false,
      isRemovePlayerFromEventConfirmationModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderRemovePlayerFromTeamConfirmationModal() {
    const { isRemovePlayerFromTeamConfirmationModalOpen, modalText, currentPlayer, selectedItems } = this.state;

    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const selectedPlayersNames = selectedItems.map(item => getFullName(item)).join(', ');
    const removing = isCurrentPlayerExist ? [currentPlayer] : selectedItems;
    const cleanup = removing.every(player => playerAvailabilityStatus(player) === 'NOT_AVAILABLE') && removing.some(player => player.events?.length);
    const modalBodyText = cleanup ? `${removing.length} not available ${removing.length === 1 ? 'student' : 'students'} will be removed from this team and their event allocations for this union will be cleared. This does not change their availability or delete their history. Continue?` : isCurrentPlayerExist
      ? modalText
      : `${selectedPlayersNames} will be removed from the team. Are you sure?`;

    return (
      <SimpleModal
        isOpen={isRemovePlayerFromTeamConfirmationModalOpen}
          title="Remove from team?"
        isBodyBold={false}
        body={<>{this.state.errorMessage && <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>}{modalBodyText}</>}
        buttonDisabled={this.state.isLoading}
          buttonText="Remove from team"
          dialogStyle={{maxWidth: 480}}
          customClass="hltDangerConfirmation"
        buttonCancelText="Cancel"
        onButtonClick={this.removePlayerFromTeam}
        onCloseClick={this.closeRemovePlayerFromTeamConfirmationModal}
      />
    );
  }

  openRemovePlayerFromTeamConfirmationModal = (): void => {
    this.setState({
      isRemovePlayerFromTeamConfirmationModalOpen: true
    });
  };

  closeRemovePlayerFromTeamConfirmationModal = (): void => {
    this.setState({
      isAskToRemovePlayerFromEvent: false,
      isRemovePlayerFromTeamConfirmationModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderPlayersWithEvents = players => {
    return (
      <ul className="mt-2">
        {players
          .filter(item => {
            const { events } = item;

            return events.length > 0;
          })
          .map(player => {
            const { id } = player;
            const playerFullName = getFullName(player);

            return <li key={id}>{playerFullName}</li>;
          })}
      </ul>
    );
  };

  renderRemovePlayerFromTeamProhibitionModal() {
    const { isRemovePlayerFromTeamProhibitionModalOpen, selectedItems, currentPlayer } = this.state;

    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const selectedPlayers = isCurrentPlayerExist ? [currentPlayer] : selectedItems;

    const modalText =
      'You cannot remove the following students as they have been added to some events within the tournament. Please remove them from the events first.';

    return (
      <SimpleModal
        isOpen={isRemovePlayerFromTeamProhibitionModalOpen}
        title="The action is prohibited"
        body={modalText}
        buttonCancelText="Cancel"
        onCloseClick={this.closeRemovePlayerFromTeamProhibitionModal}
      >
        {this.renderPlayersWithEvents(selectedPlayers)}
      </SimpleModal>
    );
  }

  openRemovePlayerFromTeamProhibitionModal = (): void => {
    this.setState({
      isRemovePlayerFromTeamProhibitionModalOpen: true
    });
  };

  closeRemovePlayerFromTeamProhibitionModal = (): void => {
    this.setState({
      isRemovePlayerFromTeamProhibitionModalOpen: false,
      currentPlayer: undefined
    });
  };

  renderAddPlayerToEventModal() {
    const { user } = this.props;
    const { isAddPlayerToEventModalOpen, selectedItems, currentPlayer } = this.state;

    const isCurrentPlayerExist = typeof currentPlayer !== 'undefined';
    const students = isCurrentPlayerExist ? [currentPlayer] : selectedItems;
    const tournamentId = this.getTournamentId();

    return (
      <SimpleModal
        isOpen={isAddPlayerToEventModalOpen}
        title="Allocate to events"
        customClass="hltStudentAllocationModal"
        dialogStyle={{maxWidth: 760}}
        isBodyBold={false}
        showFooter={false}
        onCloseIconClick={this.closeAddPlayerToEventModal}
      >
        <AddPlayerToEventForm
          isSaving={this.state.isSavingAllocations}
          students={students}
          user={user}
          tournamentId={tournamentId}
          addPlayerToEvent={this.addPlayerToEvent}
          onCloseClick={this.closeAddPlayerToEventModal}
        />
      </SimpleModal>
    );
  }

  openAddPlayerToEventModal = (): void => {
    this.setState({
      isAddPlayerToEventModalOpen: true
    });
  };

  closeAddPlayerToEventModal = (): void => {
    if (this.state.isSavingAllocations) return;
    this.setState({
      isAddPlayerToEventModalOpen: false,
      currentPlayer: undefined
    });
  };

  private updateEventAssignment = async (
    player: IndividualTournamentTeamPlayer,
    ev: TournamentTeamPlayerEvent,
    patch?: { positionId: string | null; isCaptain: boolean; sub: boolean }
  ) => {
    if (!ev || !player) return;
    const { user } = this.props;

    try {
      this.setState({ isLoading: true });

      const full = await getSchoolEvent(user, ev.id);
      const isRelay = !!propz.get(full, ['sport', 'isRelay'], false);

      const target = (full.players || []).find((p: any) => String(p.userId) === String(player.userId));
      if (!target) {
        this.setState({ isLoading: false });
        return;
      }

      const teamBased = !!ev.teamBased;

      const updateEntry = {
        id: String(target._id),
        positionId: teamBased ? patch?.positionId ?? null : null,
        isCaptain: teamBased ? !!patch?.isCaptain : false,
        sub: teamBased ? !!patch?.sub : false
      };

      if (isRelay) {
        const teamId = String(target.teamId || '');
        if (!teamId) {
          this.setState({ isLoading: false });
          return;
        }
        await updateSchoolEventTeamPlayersBatch(user, full.id, teamId, { add: [], remove: [], update: [updateEntry] });
      } else {
        await updateSchoolEventIndividualsBatch(user, full.id, { add: [], remove: [], update: [updateEntry] });
      }

      await this.setItems();
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  renderGrid() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      forms,
      isSelectAllChecked,
      currentPage,
      total
    } = this.state;
    const { user } = this.props;
    const gridTitle = 'Team members and allocations';
    const readOnly = Boolean(this.props.participationReadOnly);
    const columns = COLUMNS.filter(column => !readOnly || column.field !== 'actions').map(column => {
      if (column.field === 'events') {
        return {...column, cell: (item, options, onClick) =>
          getTeamPlayerEventsIcon(item, {...options, readOnly, modern: true}, onClick)};
      }
      if (column.field !== 'actions') return column;
      return {...column, cell: (item: IndividualTournamentTeamPlayer) => <td className="hltTeamMembers__actions">
        <button type="button" className="eDsButton eDsButton--secondary" aria-label={`Allocate events for ${getFullName(item)}`}
          onClick={() => this.onCellIconClick({currentPlayer: item}, CELL_ACTION_ICON.ADD_TO_EVENT)}>Allocate events</button>
        <div>
          <button type="button" onClick={() => this.onCellIconClick({currentPlayer: item}, CELL_ACTION_ICON.EDIT)} aria-label={`Edit ${getFullName(item)}`}>Edit</button>
          <button type="button" className="hltTeamMembers__remove" onClick={() => this.onCellIconClick({currentPlayer: item}, CELL_ACTION_ICON.REMOVE_FROM_TEAM)} aria-label={`Remove ${getFullName(item)} from team`}>Remove</button>
        </div>
      </td>};
    });

    const ageGroupName = propz.get(user, ['activeSchool', 'ageGroupsNaming'], '');

    const selectedPlayersWithEvents = selectedItems.filter(item => {
      const { events } = item;
      return events.length > 0;
    });

    const isSelectedItemsEventsExist = selectedPlayersWithEvents.length > 0;

    const actionItems = [
      {
        itemText: 'Add to an event',
        onItemClick: this.openAddPlayerToEventModal,
        isActive: selectedItems.length > 0 && !this.props.participationReadOnly
      },
      {
        itemText: 'Remove from the team',
        isDanger: true,
        onItemClick: isSelectedItemsEventsExist && !selectedItems.every(item => playerAvailabilityStatus(item) === 'NOT_AVAILABLE')
          ? this.openRemovePlayerFromTeamProhibitionModal
          : this.openRemovePlayerFromTeamConfirmationModal,
        isActive: selectedItems.length > 0 && !this.props.participationReadOnly
      }
    ];

    const filterOptions = {
      ages: getSelectOptionForAge(forms, ageGroupName),
      schoolId: getSelectOptionForSchoolOfTeam(items),
      tournamentAvailability: tournamentAvailabilityOptions,
      gender: getSelectOptionForGender()
    };

    return (
      <Grid2
        dataItems={items}
        filters={filters}
        currentPage={currentPage}
        total={total}
        isSelectAllChecked={isSelectAllChecked}
        isDataFiltered={isDataFiltered}
        sortDirection={sortDirection}
        sortColumnsName={sortColumnsName}
        isShowFilter={isShowFilter}
        dataItemsSelected={selectedItems}
        columns={columns}
        actionItems={readOnly ? [] : actionItems}
        options={filterOptions}
        onItemClick={this.onItemClick}
        onSortClick={this.onTableSortClick}
        onApplyFilterClick={this.onApplyFilterClick}
        onClearFilterClick={this.onClearFilterClick}
        onCancelFilterClick={this.onCancelFilterClick}
        onTableFilterChange={this.onTableFilterChange}
        onTableFilterClick={this.onTableFilterClick}
        onCellIconClick={this.onCellIconClick}
        setCurrentPageParams={this.setCurrentPageParams}
        onSelectAllClick={this.onSelectAllClick}
        onSelectAllOnPageClick={this.onSelectAllOnPageClick}
        onUnselectAllClick={this.onUnselectAllClick}
        gridTitle={gridTitle}
        toolbarSearchField="name"
        toolbarSearchPlaceholder="Search students..."
        hiddenFilterFields={['name']}
        isActionsInline
        selectionActionsBelow
        showClearSelection
        isSelectionHidden={readOnly}
        isSelectDisabled={readOnly}
        columnVisibilityKey="union-participation-team-members-v2"
        fixedColumnFields={['birthday', 'name', 'tournamentAvailability', 'events']}
        defaultHiddenColumns={['gender']}
        emptyText="No team members yet"
        emptyHint={readOnly ? 'No children have been added to this team.' : 'Add children from your schools or recruit them from tournament results, then allocate them to events.'}
        isCSV={false}
        user={user}
        tournament={this.props.participationTournament}
      />
    );
  }

  render() {
    const { isLoading, total, isDataFiltered } = this.state;
    const readOnly = Boolean(this.props.participationReadOnly);
    const openRecruitment = (recruit: boolean) => this.props.history.push({
      pathname: recruit ? '/highLevelTournaments/teams/recruit' : '/highLevelTournaments/teams/edit',
      search: `tournamentId=${this.getTournamentId()}&teamId=${this.getTeamId()}`,
      state: this.props.location.state
    });

    if (isLoading && !this.state.isSavingAllocations) {
      return <Loader />;
    }

    return (
      <section className="schoolInvitesList hltTeamMembers" aria-label="Team members and allocations" aria-busy={this.state.isSavingAllocations}>
        {this.state.isSavingAllocations && <div className="hltAllocationSaving" role="status"><Loader /><strong>Saving allocations…</strong></div>}
        {this.renderAddPlayerToEventModal()}
        {this.renderRemovePlayerFromEventConfirmationModal()}
        {this.renderRemovePlayerFromTeamConfirmationModal()}
        {this.renderRemovePlayerFromTeamProhibitionModal()}
        {this.renderEditStudentModal()}
        {!readOnly && <div className="hltTeamMembers__heading">
          <div className="hltTeamMembers__recruitment">
            <button type="button" className="eDsButton eDsButton--secondary" onClick={() => this.setState({isAvailabilityRequestOpen: true})}>Request availability</button>
            <button type="button" className="eDsButton eDsButton--primary" onClick={() => openRecruitment(false)}>Add from schools</button>
            <button type="button" className="eDsButton eDsButton--secondary" onClick={() => openRecruitment(true)}>Recruit from tournaments</button>
          </div>
        </div>}
        {!total && !isDataFiltered && !readOnly && <div className="hltTeamMembers__guide">
          <strong>Start building your team</strong>
          <p>Use <b>Add from schools</b> to select children from your union’s schools, or <b>Recruit from tournaments</b> to select them using results from tournaments you organised. Once added, allocate children to events below and request their availability from their schools.</p>
        </div>}
        {this.state.errorMessage && !this.state.isRemovePlayerFromTeamConfirmationModalOpen && <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>}
        {this.renderGrid()}
        {this.state.isAvailabilityRequestOpen && <AvailabilityRequestDialog user={this.props.user} tournamentId={this.getTournamentId()} onClose={() => this.setState({isAvailabilityRequestOpen: false})} onSent={() => this.setItems()} />}
      </section>
    );
  }
}
